<template>
  <div>
    <van-form label-width="62px" @submit="onSubmit">
      <van-field
        v-model="fom.card"
        readonly
        label="问题卡号"
        placeholder="用户名"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="value"
        label="问题类型"
        placeholder="点击选择问题类型"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnes"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="fom.data"
        rows="2"
        autosize
        label="问题描述"
        type="textarea"
        maxlength="50"
        placeholder="请输入留言"
        show-word-limit
      />
      <van-field name="uploader" label="文件上传">
        <template class="pp" #input>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            multiple
            :before-delete="ss"
            :max-count="5"
          />
        </template>
      </van-field>
      <van-field name="radio" label="联系方式">
        <template #input>
          <van-radio-group
            v-model="fom.contactInformationType"
            direction="horizontal"
          >
            <van-radio :name="1">微信</van-radio>
            <van-radio :name="2">手机</van-radio>
            <van-radio :name="3">QQ</van-radio>
            <van-radio :name="4">邮箱</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="fom.contactInformation"
        placeholder="请输入联系方式"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
  export default {
    props: ["fom"],
    data() {
      return {
        radio: "1",
        value: "",
        disabled: false,
        columns: [],
        columnes: [],
        showPicker: false,
        form: "",
        message: "",
        fileList: [],
        dialogVisible: false,
      };
    },
    created() {
      this.selectAll();
    },
    methods: {
      afterRead(file) {
        // 此时可以自行将文件上传至服务器
        const formData = new FormData(); // 声明一个FormData对象
        formData.append("file", file.file);
        this.axios
          .post("/app/uploadFile/add", formData, {
            headers: {
              "content-type": "multer/form-data",
            },
          })
          .then((res) => {
            this.fom.image.push(res.data.msg);
            console.log(this.fileList);
            this.fileList[this.fileList.length - 1].message = res.data.msg;
          });
      },
      ss(file) {
        console.log(file);
        this.fom.image.forEach((item) => {
          if (item == file.message) {
            this.fom.image.splice(item, 1);
          }
        });
        console.log(this.fom.image);
        this.fileList.splice(file, 1);
      },
      selectAll() {
        this.axios.get("/app/workOrderType/selectAll").then((res) => {
          if (res.data.status) {
            this.columns = res.data.data;
            this.columns.forEach((item) => {
              this.columnes.push(item.name);
            });
          }
        });
      },
      onSubmit() {
        this.columns.forEach((item) => {
          if (item.name == this.value) {
            this.fom.workOrderType = item.id;
          }
        });
        this.axios.post("/app/workOrder/insert", this.fom).then((res) => {
          if (res.data.status) {
            this.$notify({ type: "success", message: `${res.data.msg}` });
            this.fom = {
              card: localStorage.getItem("meCardNum"),
              workOrderType: "",
              data: "",
              contactInformationType: 1,
              contactInformation: "",
              image: [],
            };
          } else {
            this.$notify({ type: "warning", message: `${res.data.msg}` });
            this.fom = {
              card: localStorage.getItem("meCardNum"),
              workOrderType: "",
              data: "",
              contactInformationType: 1,
              contactInformation: "",
              image: [],
            };
          }
          this.value = "";
          this.fileList = [];
        });
      },
      onConfirm(value) {
        this.value = value;
        this.showPicker = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-upload >>> .s0ss {
    height: 40px !important;
  }
</style>
